export const cardStyles = {
  root: { border: '1px solid #C7C7CC', borderRadius: '8px' },
  header: {
    py: 2,
    px: 4,
    '& .MuiCardHeader-action': {
      marginTop: 0,
      marginRight: 0,
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  divider: { borderColor: '#C7C7CC', lineHeight: 1 },
  content: {
    px: 4,
    '&:last-child': {
      pb: 2,
    },
  },
  gutterBottom: {
    mb: 2,
  },
  actionArea: {
    '&:hover': {
      '& .MuiCardActionArea-focusHighlight': {
        opacity: 0,
      },
    },
  },
};
